import React, { FC, createContext, useState } from "react";

interface IPhaseContext {
  renderChosenSolutionToQuestion: boolean,
  dilemmaOwnerCoinCelebration: boolean,
  renderWheelOfFortune: boolean,
  setRenderChosenSolutionToQuestion(renderChosenSolutionToQuestion: boolean): void;
  setRenderDilemmaOwnerCoinCelebration(dilemmaOwnerCoinCelebration: boolean): void;
  setRenderWheelOfFortune(renderWheelOfFortune: boolean): void;
}

const PhaseContext = createContext({} as IPhaseContext);

interface PhaseContextProps {
  children: React.ReactNode;
}

const PhaseContextProvider: FC<PhaseContextProps> = (props) => {
  const [renderChosenSolutionToQuestion, setRenderChosenSolutionToQuestion] = useState<boolean>(false);
  const [dilemmaOwnerCoinCelebration, setRenderDilemmaOwnerCoinCelebration] = useState<boolean>(false);
  const [renderWheelOfFortune, setRenderWheelOfFortune] = useState<boolean>(false);

  const providerValue = {
    renderChosenSolutionToQuestion,
    dilemmaOwnerCoinCelebration,

    renderWheelOfFortune,
    setRenderChosenSolutionToQuestion,
    setRenderDilemmaOwnerCoinCelebration,
    setRenderWheelOfFortune
  };

  return (
    <PhaseContext.Provider value={providerValue}>
      {props.children}
    </PhaseContext.Provider>
  );
};

export { PhaseContext, PhaseContextProvider };
